import script from "./SidebarItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./SidebarItem.vue?vue&type=script&lang=ts&setup=true"

import "./SidebarItem.vue?vue&type=style&index=0&id=4f20c0f1&lang=scss&scoped=true"
import "./SidebarItem.vue?vue&type=style&index=1&id=4f20c0f1&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.2.2_@vue+compiler-sfc@3.4.27_vue@3.2.36_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f20c0f1"]])

export default __exports__